import { render, staticRenderFns } from "./KeywordDistribution.vue?vue&type=template&id=50de3a6f&scoped=true&"
import script from "./KeywordDistribution.vue?vue&type=script&lang=js&"
export * from "./KeywordDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de3a6f",
  null
  
)

export default component.exports